<template>
  <div class="card card-info">
    <div class="card-header with-border">
      <h3 class="card-title">Exam Admit Card</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          Roll Number
          <div class="input-group input-group-sm" style="width: 300px">
            <input type="text" class="form-control" v-mask="'#######'" placeholder="Enter Roll Number" v-model="rollnumber">
            <span class="input-group-append">
              <button class="btn btn-info btn-flat" type="button" v-on:click="searchRollnumber()">Search</button>
            </span>
          </div>
        </div>
      </div>

    </div>
    <!--Button -->
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        rollnumber: '',
      }
    },
    created: function () {
    },
    updated: function () {
    },
    methods: {
      searchRollnumber() {
        if (this.rollnumber == 0 || this.rollnumber == '') {
          toastr.error("Enter Roll Number");
          return;
        }
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/searchRollnumber?rollnumber=' + vm.rollnumber)
          .then(function (response) {
            endReq();
            if (response.data.status) {
              window.open("../Exam/ExamAdmitCardPrint", "_blank");
            }
            else {
              toastr.error(response.data.msg, "Error!")
            }
          })
      },


      cancel() {
        window.location.reload();
      }
    }
  })
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamAdmitCard.vue